import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { env } from "./lib/env";

// Only initialize Sentry in production
if (import.meta.env.PROD && env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
